export * from './wall-type-5.component'